import { ProgressCircleWebElementBase } from './ProgressCircleWebElementBase';

/**
 * The component WebElement for [oj-c-progress-circle](../../jsdocs/oj-c.ProgressCircle.html).
 * Do not instantiate this class directly, instead, use
 * [findProgressCircle](../functions/findProgressCircle.html).
 */
export class ProgressCircleWebElement extends ProgressCircleWebElementBase {
  // Put overrides here
}
